/**
 * «مشاوره رایگان»: وضعیت باز/بسته‌ی دیالوگ، جدا از خود دیالوگ.
 *
 * عمداً اینجا و نه در components/consult-dialog.tsx: سربرگ، پابرگ، جستجو و چند صفحه فقط
 * `openConsult` را لازم دارند، و اگر از آن پرونده بیاید باندلر کل فرم و وابستگی‌هایش را به
 * چانکِ ورودی می‌کشد. این پرونده هیچ وابستگی‌ای جز React ندارد.
 */
import { useSyncExternalStore } from "react";

import type { MenuLink } from "@/lib/content";

let open = false;
const listeners = new Set<() => void>();

export const setConsultOpen = (next: boolean) => {
  open = next;
  for (const listener of listeners) listener();
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

/** روی سرور همیشه بسته است؛ باز شدن فقط با کلیک کاربر معنا دارد */
export const useConsultOpen = () =>
  useSyncExternalStore(
    subscribe,
    () => open,
    () => false,
  );

/** فرم مشاوره را باز می‌کند؛ در صفحه‌ی یک خودرو همان خودرو از پیش انتخاب شده است */
export const openConsult = () => setConsultOpen(true);

/** پیوندهای منو که به بخش مشاوره‌ی صفحه‌ی اصلی می‌روند، به‌جای پرش فرم را همان‌جا باز می‌کنند */
export const isConsultLink = (link: MenuLink) =>
  !link.external && /^\/?#consult(-form)?$/.test(link.href);
